import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import history from "../../history";
import { fetchBasket } from "../../services/basket/actions";
import {
  changeLocation,
  fetchLocationsInBasket,
} from "../../services/currentInformation/actions";
import { loginAPI } from "../../services/login/actions";

function LocationComponent(props) {
  const [name, setName] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    setName(props.currentLocation.name);
    setId(props.currentLocation.id);
    props.fetchLocationsInBasket(props.userId);
    props.fetchBasket(props.currentLocation.id, props.userId);
  }, [props.currentLocation.id]);

  const handleChange = (event) => {
    setName(event.target.name);
    props.changeLocation(event.target.value);
  };

  const getLocationIndex = (id, list) => {
    for (let i = 0; i < list.length; i++) {
      if (parseInt(list[i].id) === parseInt(id)) {
        return i;
      }
    }
  };

  var whichScreen = () => {
    switch (history.location.pathname) {
      case "/confirmorder":
        return props.locationsInBasket.map((location) => (
          <MenuItem value={location}>{location.name}</MenuItem>
        ));
      default:
        return props.locationList.map((location) => (
          <MenuItem value={location}>{location.name}</MenuItem>
        ));
    }
  };

  const singleLocationOrMultiple = (whichList) => {
    if (props.locationList.length === 1) {
      return (
        <div style={{ width: 300 }}>
          <Box
            align="center"
            variant="outlined"
            fullWidth="true"
            border={1}
            borderRadius={4}
          >
            <br />

            {props.currentLocation.name}
            <br />
            <br />
          </Box>
        </div>
      );
    } else
      return (
        <div>
          <FormControl variant="outlined" fullWidth="true">
            <InputLabel id="demo-simple-select-outlined-label">
              Kies uw locatie
            </InputLabel>
            <Select
              style={{ margin: "0px 5px" }}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Kies uw locatie"
              value={
                whichList[getLocationIndex(props.currentLocation.id, whichList)]
              }
              onChange={handleChange}
            >
              {whichScreen()}
            </Select>
          </FormControl>
        </div>
      );
  };

  var whichList =
    history.location.pathname === "/confirmorder"
      ? props.locationsInBasket
      : props.locationList;

  return singleLocationOrMultiple(whichList);
}

const mapStateToProps = (state) => ({
  locationList: state.login.data.all_locations,
  currentLocation: state.currentInformation.current_location,
  locationsInBasket: state.currentInformation.locations_in_basket,
  userId: state.login.data.user_id,
});

export default connect(mapStateToProps, {
  changeLocation,
  loginAPI,
  fetchLocationsInBasket,
  fetchBasket,
})(LocationComponent);
